import styled from 'styled-components';

export const ImageOverlay = styled.article`
  --normal-color: #424748;
  --normal-h2-h3-color: #050a30;

  position: relative;
  min-height: 300px;
  background: ${({ $img }) => $img && `url(${$img}) no-repeat center center / cover;;`};
  color: #fff;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
  & > * {
    width: 100%;
    color: #fff;
    position: relative;
    z-index: 2;
  }
`;

export const CharterSection = styled.section`
  margin: 32px 0;

  @media (max-width: 757px) {
    margin: 16px 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 200px;
  justify-content: space-between;
  align-items: center;
`;

export const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const H3Text = styled.h3`
  font-weight: var(--fw-bold);
  font-size: var(--fs-800);
  color: var(--color-theme);
`;

export const H2Text = styled.h2`
  font-size: 40px;
  font-weight: 600;
  color: var(--normal-h2-h3-color);
  line-height: normal;
  white-space: pre-line;
  margin: 0;
`;

export const H3Text1 = styled.h3`
  font-size: 20px !important;
  font-weight: 600;
  color: var(--normal-h2-h3-color);
  line-height: normal;
`;

export const NormalSpan = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: var(--normal-h2-h3-color);
  line-height: 1.3;
`;
